// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {EventAttachment, SimUser} from "@models";
import {Translations} from "@translations";
import {SimEventService} from "@services";

@Component({
	selector: "sim-attachment-item",
	templateUrl: "./attachment-item.component.html",
	styleUrls: ["./attachment-item.component.scss"],
	standalone: false,
})
export class AttachmentItemComponent implements OnInit {
	T = Translations;

	@Input() attachment: EventAttachment;
	@Input() eventId: string;
	@Input() editable: boolean;
	@Input() disableDelete: boolean = false;
	@Input() disableDownload: boolean = false;
	onDeleted = output<EventAttachment>();

	constructor(protected _simEventService: SimEventService) {}

	ngOnInit(): void {}

	deleteClicked() {
		this.onDeleted.emit(this.attachment);
	}

	downloadAttachments() {
		window.location.href = this._simEventService.downloadEventAttachment_Url(this.eventId, this.attachment.id);
	}
}
